var n=function(){};export{n as noop};
//# sourceMappingURL=noop.js.map
